import React, { useEffect, useState } from 'react';
import BsModal from '../../Common/BsModal';
import { useConfig } from '../../../DataStore/ConfigContext';
import TextInput from '../../Common/TextInput';
import { usePermission } from '../../../DataStore/PermissionContext';
import { useTheme } from '../../../DataStore/ThemeContext';
import Notification from '../../Common/Notification';
import ActivityLoader from '../../Common/ActivityLoader';
import ajaxUser from '../../../util/remote/ajaxUser';

const PopAssignRolePermission = () => {
    const [roleId, setRoleId] = useState(null);
    const {getUserRoles, userRoles} = useConfig();
    const {accessAllocation, setAccessAllocation} = usePermission();
    const [loading, setLoading] = useState(false);
    const {setNotify} = useTheme();

    useEffect(() => {
        getUserRoles(); // Fetch user roles when the modal is shown
    }, []);
    
     
    const handleConfirm = async() => {
        setLoading(true);
        const payload = {
            role_id: roleId,
            permission_ids: accessAllocation.permissions
        };
        const server_response = await ajaxUser.assignMultiPermissions(payload);
        setLoading(false);
        if(server_response.status === "OK"){
            setNotify(<Notification type="success" message={server_response.message}/>)
        }else{
            setNotify(<Notification type="danger" message={server_response.message}/>)
        }
        handleClose(); // Close the modal
    };

    const handleClose = () => {
        setAccessAllocation({show: false, permissions: null, callback: null});
        setRoleId(null); // Reset roleId when closing the modal
    }
  

    return (
        <BsModal
            show={accessAllocation.show}
            onClose={handleClose}
            title="Permission Assignment"
            footer={
                <>
                  {loading && <ActivityLoader />}
                  {!loading && <>
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={handleClose}
                        >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleConfirm}
                        disabled={!roleId}
                        >
                        <i className="fa fa-check-circle mr-1"></i> Assign Permissions
                    </button>
                    </>}
               </>
            }
            >

            <TextInput
                label="Select Role"
                type="select"
                value={roleId}
                onChange={(role) => setRoleId(role.value)}
                options={Array.isArray(userRoles) ? userRoles.map((role) => ({
                    value: role.id,
                    label: role.role_name
                })) : []}
                placeholder="Select a role"
                wrap
                leftComponent={<i className="fa fa-user-tag"></i>}
                // leftIcon={true}
            />
            
            <p className="text-muted mt-2">
                Please select a role to assign the selected permissions.
            </p>
           
            
           

        </BsModal>
    );
};

export default PopAssignRolePermission;
